const BASE_URL = window.location.origin; //process.env.REACT_APP_INTERNAL_SERVER_URL;
export default BASE_URL;
